export const RouteStopsComponentName: string = 'routeStops';
